import http from '@/utils/http';

export default {
	login: data => {
		return http({ url: '/api/admin/v1/login/login', data, loading: true }).then(r => r);
	},
	changePassword: data => {
		return http({ url: '/api/admin/v1/user/updatePassword', data, tip: true, loading: true }).then(r => r);
	},
	orgTree: data => {
		return http({ url: '/api/admin/v1/dept/orgTree', data }).then(r => r);
	},
	list: data => {
		return http({ url: '/api/admin/v1/user/list', data }).then(r => r);
	},
	save: data => {
		return http({ url: '/api/admin/v1/user/save', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/user/delete', data, tip: true }).then(r => r);
	},
	lock: data => {
		return http({ url: '/api/admin/v1/user/lock', data, tip: true }).then(r => r);
	},
};
